module.exports = __webpack_public_path__ + "static/media/zoleLose_5000_10000.46fd0955.png";